import Header from './loom_lead_detail/Header';
import Careplan from './loom_lead_detail/Careplan';
import CaregiverConnections from './loom_lead_detail/CaregiverConnections';
import CareviewSettings from './loom_lead_detail/CareviewSettings';

export default {
  LoadError: 'Could not load this lead from Loom. Check the link, or refresh to try again.',
  Header,
  Careplan,
  CaregiverConnections,
  CareviewSettings,
  Workflows: {
    Title: 'Workflows',
    Empty: 'This client has no workflows.',
    LoadError: 'Could not load the workflows. Refresh to try again.',
    Started: 'Started #{value}',
    Updated: 'Updated #{value}',
    Completed: 'Completed #{value}',
    Type: {
      LEAD_INTAKE: 'Lead intake',
    },
    Steps: {
      IntakeReceived: 'Intake received',
      ContactingLead: 'Contacting lead',
      Finished: 'Booked or closed',
      Booked: 'Call booked',
      Closed: 'Closed',
    },
    State: {
      NOT_STARTED: 'Not started',
      PROCESSING: 'Processing intake',
      AWAITING_LEAD: 'Waiting on lead',
      TEAM_REVIEW: 'Needs team review',
      IN_PROGRESS: 'In progress',
      COMPLETING: 'Completing',
      BOOKED: 'Call booked',
      CLOSED: 'Closed',
    },
    Complete: {
      Action: 'Complete workflow',
      Title: 'Complete workflow',
      Body: 'This ends the lead intake as a booked sales call. The lead gets no message, and follow-ups stop. You cannot undo this.',
      Confirm: 'Complete',
      Errors: {
        WFL_006: 'This workflow can no longer be completed. Refresh to see its current state.',
        Default: 'Could not complete the workflow. Try again.',
      },
    },
    Attention: {
      Title: 'Needs attention',
      NoEngineRun: 'The workflow engine did not start this workflow. It will not advance.',
      EscalationFailed: 'A team review could not be sent to Slack.',
      TeamReview: 'The workflow is paused until the team resolves the review in Slack.',
    },
    Details: {
      Submitter: 'Submitted by',
      Contact: 'Contact',
      Channel: 'Channel',
      FollowUps: 'Follow-ups sent',
      Outcome: 'Outcome',
      FinalResult: 'Final result',
      LostReason: 'Lost reason',
      Booking: 'Sales call',
    },
    Channel: {
      EMAIL: 'Email',
      SMS: 'SMS',
    },
    Outcome: {
      SALES_CALL_BOOKED: 'Sales call booked',
      CLOSED_LOST: 'Closed lost',
      STALLED: 'Stalled',
      UNRESPONSIVE: 'Unresponsive',
    },
    LostReason: {
      TERMINATED: 'Ended by the team',
      DECLINED: 'Declined',
      DO_NOT_CONTACT: 'Do not contact',
      IMMEDIATE_CARE_UNAVAILABLE: 'Immediate care not available',
      NO_LONGER_NEEDED: 'No longer needed',
      CLIENT_DECEASED: 'Client deceased',
    },
    Timeline: {
      Show: 'Show history (#{count})',
      Hide: 'Hide history',
      Handled: 'Handled #{value}',
      CompletedBy: 'By #{value}',
      Escalation: 'Team review',
      Draft: 'Draft message',
      Decided: '#{decision} #{value}',
      Delivery: {
        PENDING: 'Waiting to send',
        SENDING: 'Sending',
        SENT: 'Sent to Slack',
        SUPPRESSED: 'Not sent',
        FAILED: 'Failed to send',
      },
      Decision: {
        APPROVED: 'Approved',
        REJECTED: 'Rejected',
        RESUMED: 'Resumed',
        TERMINATED: 'Ended',
      },
      Signal: {
        INTAKE_FORM_SUBMITTED: 'Intake form submitted',
        WORKFLOW_TIMER_DUE: 'Follow-up timer due',
        SALES_CALL_BOOKED: 'Sales call booked',
        TEAM_REVIEW_RESOLVED: 'Team review resolved',
        WORKFLOW_COMPLETED_MANUALLY: 'Completed in CareOS',
      },
    },
  },
  IntakeForm: {
    Title: 'Intake form',
    Empty: 'This client has no intake form.',
    LoadError: 'Could not load the intake form. Refresh to try again.',
    Submitted: 'Submitted #{value}',
    SubmittedBy: 'Submitted by',
    Contact: 'Contact',
  },
  Correspondance: {
    Title: 'Communications',
    Empty: 'This client has no messages.',
    LoadError: 'Could not load the messages. Refresh to try again.',
    More: 'Showing the latest #{count} messages.',
    Truncated: 'This message is shortened.',
    From: 'From #{value}',
    To: 'To #{value}',
    Direction: {
      INBOUND: 'Received',
      OUTBOUND: 'Sent',
    },
    Channel: {
      EMAIL: 'Email',
      SMS: 'SMS',
    },
  },
};
